import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../ApiConfig/ApiConfig';

function ResetPassword() {
    const { token } = useParams();  // Get the token from the URL
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check if passwords match
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        // Send token along with the new password
        try {
            await axios.post(`${API_BASE_URL}/admin/reset-password`, { token, newPassword });
            setMessage('Password reset successfully.');
            setIsModalOpen(true); // Show modal on success
        } catch (err) {
            setError('Error resetting password. The link may have expired.');
        }
    };

    const handleOkClick = () => {
        setIsModalOpen(false); // Close the modal
        navigate('/admin/login'); // Redirect to login page
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-6 rounded shadow-2xl w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center">Reset Password</h2>
                {message && <p className="text-green-500 text-center">{message}</p>}
                {error && <p className="text-red-500 text-center">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="newPassword" className="block text-sm font-semibold mb-2">New Password</label>
                        <input
                            type="password"
                            id="newPassword"
                            className="w-full p-2 border border-gray-300 rounded"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="confirmPassword" className="block text-sm font-semibold mb-2">Confirm Password</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            className="w-full p-2 border border-gray-300 rounded"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded">
                        Reset Password
                    </button>
                </form>
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded shadow-lg max-w-sm text-center">
                        <h3 className="text-xl font-semibold text-green-600">Password Reset Successfully</h3>
                        <p className="mt-4 text-gray-600">You can now log in with your new password.</p>
                        <button
                            onClick={handleOkClick}
                            className="mt-6 bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600"
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ResetPassword;
